/**
 * DEV-ONLY role preview override.
 *
 * Lets you preview how the portal looks for a different role (e.g. consultant,
 * support) WITHOUT changing the real Firestore role. It is completely disabled
 * outside development builds, so it never affects production.
 *
 * Usage (while running locally):
 *   http://localhost:3000/dashboard?previewRole=consultant
 *   http://localhost:3000/dashboard?previewRole=support
 *   http://localhost:3000/dashboard?previewRole=off      (back to your real role)
 *
 * The choice is remembered in sessionStorage so it persists while you navigate.
 */

const VALID_ROLES = ['admin', 'consultant', 'support'];
const STORAGE_KEY = 'previewRoleOverride';

const isDev = () => process.env.NODE_ENV === 'development';

export const getPreviewRole = () => {
  if (!isDev() || typeof window === 'undefined') return null;

  try {
    const param = new URLSearchParams(window.location.search).get('previewRole');
    if (param) {
      const value = param.toLowerCase();
      if (value === 'off' || value === 'real' || value === 'none') {
        window.sessionStorage.removeItem(STORAGE_KEY);
      } else if (VALID_ROLES.includes(value)) {
        window.sessionStorage.setItem(STORAGE_KEY, value);
      }
    }
    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    return VALID_ROLES.includes(stored) ? stored : null;
  } catch {
    return null;
  }
};

export const clearPreviewRole = () => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
};
